export const INSTORE_OFFERS_SORT = 'INSTORE_OFFERS_SORT';

export const ALPHABETICAL_ORDER = 'alphabetical';
export const LINKED_ORDER = 'linkedOffers';
export const NEAR_ME = 'nearMe';
export const EARN_RATE = 'earnRate';
